var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "capture_tool",
    "data-name": "capture tool",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    className: "themeSVGStroke themeSVGStrokeHover",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "themeable",
    x: 4.08,
    y: 7.56,
    width: 23.83,
    height: 15.17,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "themeable",
    x: 3,
    y: 4.31,
    width: 26,
    height: 3.25,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    className: "themeable",
    x1: 12.46,
    y1: 28.57,
    x2: 19.54,
    y2: 28.57,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    className: "themeable",
    x1: 16,
    y1: 22.73,
    x2: 16,
    y2: 28.57,
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1984",
    "data-name": "Rectangle 1984",
    width: 32,
    height: 32,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.1252e0cceeb403ed85281707af21f2fe.svg";
export { ForwardRef as ReactComponent };